'use strict';

var React = require('react');
var cellSubText_styles = require('./cellSubText.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const CellSubText = ({ subText, text, ...props }) => (React__default.default.createElement(cellSubText_styles.CellSubTextStyled, { noVerticalPadding: true, ...props },
    React__default.default.createElement("span", null, text),
    React__default.default.createElement("br", null),
    React__default.default.createElement(cellSubText_styles.CellSubTextSecondaryText, null, subText)));

exports.CellSubText = CellSubText;
//# sourceMappingURL=cellSubText.js.map
